/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-16 17:15:27
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-06-21 18:02:00
 * @FilePath: /unifyxp-v2-store-portal/src/components/LinkModule/util.ts
 */
import { linkData } from 'src/request/link/index';
import { LinkModuleType } from '@/src/types/common/linkType';
import { get } from 'lodash';

const outContentKey = 'SalesChannelOuterContent';

const variableSelection = (linkType, keys, values) => {
  if (linkType === LinkModuleType.ContentPage) {
    return {
      contextType:
        (keys || []).length !== 0
          ? (keys || []).includes(outContentKey)
            ? outContentKey
            : get(keys, '0')
          : null,
      contextUuid: (values || []).length !== 0 ? get(values, '0') : null,
    };
    //SalesChannelOuterContent
  } else {
    return {
      contextType: (keys || []).length !== 0 ? get(keys, '0') : null,
      contextUuid: (values || []).length !== 0 ? get(values, '0') : null,
    };
  }
};

export const fetchData = async (
  linkType?: string,
  scopeVariables?: Record<string, string>,
  keyword?: string,
  fetchProps?: { [propsName: string]: any },
) => {
  let keys = [];
  let values = [];
  if (scopeVariables) {
    keys = Reflect.ownKeys(scopeVariables);
    values = Object.values(scopeVariables);
  }

  const data = await linkData({
    linkTypes: linkType ? [linkType] : null,
    ...variableSelection(linkType, keys, values),
    // contextType: keys.length !== 0 ? keys[0] : null,
    // contextUuid: values.length !== 0 ? values[0] : null,
    // onlyShowVisibleProduct: true,
    ...(fetchProps || {}),
    keyword,
  });
  return data;
};

export const spliceProductDesc = (item) => {
  return `${Array.isArray(item.skus) ? item.skus.join(',') : ''} | ${
    item.isAlias ? 'Alias' : 'Original'
  }${item.remarks ? `| ${item.remarks}` : ''}`;
};

export const urlValidate = (value: string) => {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i',
  );
  return !!pattern.test(value.replace(/http(s?):\/\//, '//'));
};

export const transform = (type: any) => {
  return {
    label: type.name,
    uuid: type.uuid,
    linkType: type.linkType,
    action: type.action || null,
    item: {
      hasError: false,
    },
  };
};

export const parseUrlTitle = (url: string) => {
  const link = /http(s?):\/\//.test(url)
    ? url.replace(/http(s?):\/\//, '//')
    : `//${url}`;
  return window
    .fetch(link)
    .then((response) => response.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const title = doc.querySelectorAll('title')[0];
      return title.innerText;
    })
    .catch((e) => {
      console.log(e, 'e');
      return '';
    });
};

export const categorizeLinkLibrary = (list: Array<any>) => {
  const urlList = list.filter((v) => v.category === 'URL') || [];
  const miniProgram = list.filter((v) => v.category === 'MiniProgram') || [];
  return {
    urlList,
    miniProgram,
  };
};
